module.exports = "//cdn.cnbj2m.fds.api.mi-img.com/rdp-outer/qiankun-admin/202601191108228/img/app-button.d6fa2024.svg";